// extracted by mini-css-extract-plugin
export default {"EmptyState":"EmptyStateComments_EmptyState__OSwqL"};